<section class="content content_no-padding">
  <main class="container-fluid">
    <div class="row">
      <div class="col-12 col-lg-2 offset-lg-2 d-flex flex-column flex-lg-row justify-content-start align-items-start">
        <img src="/assets/images/decision-reject.svg" alt="" />
      </div>
      <div
        class="col-12 col-lg-5 d-flex flex-column align-items-center align-items-lg-start justify-content-center text-md-left"
      >
        <ng-content />
      </div>
    </div>
  </main>
  <footer>
    <app-support />
  </footer>
</section>
